import { render, staticRenderFns } from "./PaymentCollectionReportPrintDialog.vue?vue&type=template&id=f1df8744"
import script from "./PaymentCollectionReportPrintDialog.vue?vue&type=script&lang=js"
export * from "./PaymentCollectionReportPrintDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports